import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/Select');
};

export const SenderRegistration = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/SenderRegistration');
};

export const GenerateOTPForSender = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/GenerateOTPForSender');
};

export const VerifyOTPForSender = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/VerifyOTPForSender');
};

export const AadhaarBiometricForSender = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/AadhaarBiometricForSender');
};

export const ViewBeneficiary = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/ViewBeneficiary');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/AddBeneficiary');
};

export const DeleteBeneficiary = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/DeleteBeneficiary');
};

export const GetSplitAmountForTransaction = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/SplitAmountForTransaction');
};

export const GenerateOTPForSplitAmount = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/GenerateOTPForSplitAmount');
};

export const MoneyTransfer = async (request) => {
    return PostAPI(request, 'OnlyAPIDMT/MoneyTransfer');
}; 
